export const isObjNotNull = <TItem = unknown>(item: unknown): item is TItem =>
  typeof item === 'object' && item !== null;

export const isObjLiteral = <TItem>(item: unknown): item is TItem =>
  (!Array.isArray(item) && isObjNotNull(item)) as any;

export const isArray = <TItem = unknown>(item: any): item is TItem[] =>
  Array.isArray(item) && isObjNotNull(item);

export default {
  isObjNotNull,
  isObjLiteral,
  isArray
};
